<template>
    <div style="width: 95%;">
      <div v-if="files.length>0" style="display:flex; flex-wrap:wrap">
        <div v-for="(file, index) in files" v-bind:key="index" style="padding:1rem; text-align:center" class="btn btn-link fileitem" @click="downloadFile(file)">
          <i class="fa fa-times" style="padding-left: 0em;" @click.stop="deleteFile(file)"></i>

          <i v-if="file.filetype === 'pdf'" class="fa fa-file-pdf-o fa-4x" style="padding-left: 0em;"></i>
          <i v-else-if="file.filetype === 'csv'" class="fa fa-file-code-o fa-4x" style="padding-left: 0em;"></i>
          <i v-else-if="file.filetype === 'png' || file.filetype === 'jpg'" class="fa fa-file-image-o fa-4x" style="padding-left: 0em;"></i>
          <i v-else-if="file.filetype === 'txt'" class="fa fa-file-text-o fa-4x" style="padding-left: 0em;"></i>
          <i v-else class="fa fa-file-o fa-4x" style="padding-left: 0em;"></i>
          <br>
          <span v-if="file.titulo">{{file.titulo}}</span>
          <span v-else>Fichero sin nombre</span>
          <!-- <b-button @click="deleteFile(file)">Eliminar</b-button> -->
        </div>
      </div>
      <!-- <b-table v-if="files.length>0" striped hover :items="files" :fields="table_fields">
        <template slot="actions" slot-scope="row">
        </template>
        <template slot="titulo" slot-scope="row">
          <b-button variant="link" @click="downloadFile(row.item)">{{row.item.titulo}}</b-button>
        </template>
      </b-table> -->
      <template v-else>
        <br>
        <span style="color:red"><strong>No se han encontrado ficheros.</strong></span>
      </template>
      <br><br>
      <b-row>
        <b-col v-if="hasPermision('E')">
          <input type="file" name="file" id="file" @change="uploadFile($event.target.files)" class="inputfile"/>
          <label for="file">
            <span class="btn btn-success">Subir fichero</span>
          </label>
          <!-- <b-button @click="updateFile">Añadir Fichero</b-button> -->
        </b-col>
      </b-row>
    </div>
</template>

<style>
.inputfile {
 width: 0.1px;
 height: 0.1px;
 opacity: 0;
 overflow: hidden;
 position: absolute;
 z-index: -1;
}

.fileitem {
    position: relative;
    display: inline-block;
}
.fileitem i:first-child{
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
.fileitem:hover i:first-child {
    display: block;
}
</style>

<script>
import Switches from 'vue-switches';
import saveAs from 'file-saver';

export default {
  name: 'ComercialGestion',
  props: ['feature', 'type', 'permisos'],
  components: {
    Switches
  },
  data () {
    return {
      newFile: null,
      table_fields: [
        { key: 'actions', label: 'Acciones' },
        { key: 'titulo', label: 'Titulo' }
      ],
      files: []
    };
  },
  mounted: function () {
    this.getFiles();
  },
  methods: {
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    },
    downloadFile: function (item) {
      saveAs(this.$http.options.root.split('api/')[0] + 'media/' + item.archivo.split('multimedia/')[1], item.titulo);
    },
    deleteFile: function (file) {
      this.$http.delete(this.type + '_multimedia/' + file.id + '/').then(result => {
        this.getFiles();
      });
    },
    getFiles: function () {
      if (this.type === 'comercial') {
        this.$http.get('comercial_multimedia/', {params: {not_paginated: true, id_comercial: this.feature.properties.id}}).then(result => {
          this.files = result.data.map(function (e) {
            e.filetype = e.archivo.split('.')[1];
            return e;
          });
        });
      } else {
        this.$http.get('caldera_multimedia/', {params: {not_paginated: true, id_caldera: this.feature.properties.id}}).then(result => {
          this.files = result.data.map(function (e) {
            e.filetype = e.archivo.split('.')[1];
            return e;
          });
        });
      }
    },
    uploadFile: function (files) {
      const formData = new FormData();
      formData.append('file', files[0], files[0].name);

      if (this.type === 'comercial') {
        formData.append('id_comercial', this.feature.properties.id);

        this.$http.post('upload_comercial/', formData).then(result => {
          this.getFiles();
          this.$emit('comercialSaved');
        });
      } else {
        formData.append('id_caldera', this.feature.properties.id);

        this.$http.post('upload_caldera/', formData).then(result => {
          this.getFiles();
          this.$emit('calderaSaved');
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/comercial_multimedia.vue